export const blocksAction = {
    SET_BLOCKS: 'SET_BLOCKS',
    APPEND_BLOCKS: 'APPEND_BLOCKS',
    SET_SHOW_WARNING: 'SET_SHOW_WARNING'
}